module.exports = __webpack_public_path__ + "img/icon5.13d8d7d5.svg";